"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDecoration = void 0;
const React = require("react");
const layouts_1 = require("../../../../types/layouts");
const Img_1 = require("../Img");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "InputDecoration");
/**
 * Used to wrap one or more input fields and provide common elements, e.g. errors,
 * labels, decorations, etc.
 */
const InputDecoration = ({ label, description, descriptionImageUrl, hasError = false, isRequired = false, layout = layouts_1.TLayoutDirections.Column, children }) => {
    // Wraps all parts of the input
    const formInputClasses = css("", `-layout-${layout}`, {
        "-error": hasError
    });
    return (React.createElement("div", { className: formInputClasses, "data-test": "form-input", "data-layout": layout },
        React.createElement("div", { className: css("container") },
            label && (React.createElement("label", { className: css("label"), "data-test": "label" },
                label,
                " ",
                !isRequired && (React.createElement("span", { className: css("label_optional") }, "(optional)")))),
            React.createElement("div", { className: css("description", {
                    "-withImage": !!descriptionImageUrl
                }) },
                descriptionImageUrl && (React.createElement("div", { className: css("descriptionImage") },
                    React.createElement(Img_1.Img, { responsive: true, src: descriptionImageUrl }))),
                description && (React.createElement("div", { dangerouslySetInnerHTML: { __html: description }, "data-test": "description" })))),
        children));
};
exports.InputDecoration = InputDecoration;
//# sourceMappingURL=index.js.map